// _ 언더바 사용 불가. 언더바 있을 경우 링크가 플랫폼 웹사이트 화면으로 이동함.
// URL 이라 대소문자 구분없음
const project_name = 'aslanuser'; 

export function getBrand() {
  const platform = navigator.platform.toLowerCase();
  const userAgent = navigator.userAgent.toLowerCase();

  if (/iphone/i.test(platform) || /macintosh/i.test(userAgent) || /ipad/i.test(platform)) {
    // iOS (iPhone, iPad) 환경
    // 각 함수별로 파라미터가 다르므로, 각각의 함수에서 정의한다. 
    return null;
  } else {
    return window.aslanuser;
  }
}

function objectToQueryString(params: Record<string, any>): string {
  const queryString = new URLSearchParams(params).toString();
  return "?" + queryString;
}

function getUrlScheme(func_name: string, params?: Record<string, any>){
  let result = project_name + '://' + func_name;
  if(params) result += objectToQueryString(params);
  // console.log('result',result);

  return result;
}

// App Bridge --------------------------------------------------------------
export function test() {
  const brand = getBrand();
  if (brand) {
    brand.test();
  }else{
    const data = {
      specialChar: "가나다라"
    }
    window.location.href = getUrlScheme('test', data);
  }
}

export function logout() {
  const brand = getBrand();
  if (brand) {
    brand.logout();
  }else{
    window.location.href = getUrlScheme('logout');
  }
}

export function webviewClose() {
  const brand = getBrand();
  if (brand) {
    brand.webviewClose();
  }else{
    window.location.href = getUrlScheme('webviewClose');
  }
}